import { cn } from "@util/tailwind";
import { Button } from "@component/button";

interface Step {
    id: string;
    title: string;
    description?: string;
}

interface ProgressTrackerProps {
    isEditMode?: boolean;
    steps: Step[];
    currentStep: number;
    className?: string;
    showNextButton?: boolean;
    isDisabled: boolean;
    isLoading?: boolean;
    onNext: () => void;
    onPrevious: () => void;
    onSubmit: () => void;
}

export default function ProgressTrackerJob({
    steps,
    currentStep,
    className,
    showNextButton = false,
    isDisabled = false,
    isLoading = false,
    onNext,
    onPrevious,
    onSubmit,
}: ProgressTrackerProps) {

    return (
        <div
            className={cn(
                "fixed bottom-[70px] sm:bottom-0 left-0 right-0 w-full bg-white border-t border-gray-200 px-6 py-4",
                className
            )}
        >
            <div className="flex items-center justify-between gap-2">
                <div className="sm:flex-1" />
                <div className="flex-1 flex justify-center w-full">
                    <p className="text-sm font-medium text-gray-900">
                        Step {currentStep} of {steps.length}
                    </p>
                </div>
                <div className="flex-1 flex justify-end">
                    {showNextButton && (
                        <div className="flex gap-3">
                            {currentStep > 1 && (
                                <Button variant="outline" onClick={onPrevious}>
                                    Previous
                                </Button>
                            )}
                            {(currentStep === 4) ? (
                                <Button
                                    onClick={onSubmit}
                                    disabled={isLoading || isDisabled}
                                    className="bg-blue-600 hover:bg-blue-700"
                                >
                                    {isLoading ? "Please wait..." : "Publish Job"}
                                </Button>
                            ) : (
                                <Button
                                    onClick={onNext}
                                    disabled={isDisabled}
                                    className="bg-blue-600 hover:bg-blue-700"
                                >
                                    Next
                                </Button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
